<template>
  <div>
    <div class="m-b-20 ovf-hd">
      <!-- <div class="fl m-r-30" v-show="addShow">
        <router-link class="btn-link-large add-btn" to="add">
          <i class="el-icon-plus"></i>&nbsp;&nbsp;添加用户
        </router-link>
      </div> -->
      <div class="fl w-400">
        <el-input placeholder="请输入姓名/企业名/报销消费事由/备注/票据类型" clearable v-model="keywords">
          <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
        </el-input>
      </div>
    </div>
    <el-table
    :data="tableData"
    :height="setHeight.page_height"
    style="width: 100%"
    border
    @selection-change="selectItem">
      <el-table-column
      type="selection"
      width="50">
      </el-table-column>
      <el-table-column
      prop="id"
      label="ID">
      </el-table-column>
      <el-table-column
      prop="company_name"
      label="企业">
      </el-table-column>
      <el-table-column
      prop="user_name"
      label="报销人">
      </el-table-column>
      <el-table-column
      prop="reason"
      label="报销事由"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="consume_money"
      label="报销金额">
      </el-table-column>
      <el-table-column
      label="报销状态">
        <template scope="scope">
          <div>
            <span v-if = "scope.row.status ==-1">删除</span>
            <span v-if = "scope.row.status ==0">保存</span>
            <span v-if = "scope.row.status ==1">待审批</span>
            <span v-if = "scope.row.status ==2">待审核</span>
            <span v-if = "scope.row.status ==3">待核销</span>
            <span v-if = "scope.row.status ==4">已驳回</span>
            <span v-if = "scope.row.status ==5">待支付</span>
            <span v-if = "scope.row.status ==6">已完成</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
      prop="cost"
      label="票据类型">
      </el-table-column>
      <el-table-column
      prop="consume_time"
      label="消费时间">
      </el-table-column>
      <el-table-column
      prop="consume_reason"
      label="消费事由"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="create_time"
      label="申请时间">
      </el-table-column>
      <el-table-column
      prop="remarks"
      label="备注"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="bill_url"
      label="发票">
        <template scope="scope">
          <el-popover
            v-if="scope.row.bill_url"
            placement="right-end"
            width="400"
            trigger="click">
            <img :src="scope.row.bill_url" width="100%">
            <img :src="scope.row.bill_url" width="50" height="50" slot="reference">
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
      label="操作">
        <template scope="scope">
          <div>
            <span>
              <el-button size="small" type="primary" @click="$router.push({ name: 'billEdit', params: { id: scope.row.id }})">编辑</el-button>
              <!-- <el-button size="small" type="primary" @click="details(scope.row)">详情</el-button> -->
            </span>
            <span>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-drawer
      title="详情"
      :visible.sync="dialogVisible"
      :direction="direction">
      <div>
        企业：<span><b>{{detail.company_name}}</b></span>
      </div>
      <div>
        部门：<span><b>{{detail.branch}}</b></span>
      </div>
      <div>
        报销人：<span><b>{{detail.user_name}}</b></span>
      </div>
      <div>
        报销事由：<span><b>{{detail.reason}}</b></span>
      </div>
      <div>
        报销金额：<span><b>{{detail.consume_money}}</b></span>
      </div>
      <div>
        报销状态：<span><b>{{detail.status}}</b></span>
      </div>
      <div>
        票据类型：<span><b>{{detail.cost}}</b></span>
      </div>
      <div>
        消费时间：<span><b>{{detail.consume_time}}</b></span>
      </div>
      <div>
        消费事由：<span><b>{{detail.consume_reason}}</b></span>
      </div>
      <div>
        申请时间：<span><b>{{detail.create_time}}</b></span>
      </div>
      <div>
        备注：<span><b>{{detail.remarks}}</b></span>
      </div>
      <div>
        发票：<span><img :src="detail.bill_url" class="w-100"></span>
      </div>
    </el-drawer>
    <div class="pos-rel p-t-20">
      <btnGroup :selectedData="multipleSelection" :type="'bill'"></btnGroup>
      <div class="block pages">
        <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :page-size="limit"
        :current-page="currentPage"
        :total="dataCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<style scoped>
.rtl{
    width:520px !important;
    color:#555 !important;
  }
  .rtl .el-drawer__header span{
    font-size:40px !important;
    color:#111 !important;
  }
  .rtl div{
    margin-left:35px;
    color:#555;
  }
  .rtl div span{
    color:#111;
  }
</style>
<script>
  import btnGroup from '../../../Common/btn-bill-group.vue'
  import http from '../../../../assets/js/http'

  export default {
    data() {
      return {
        showbtn: false,
        tableData: [],
        dataCount: null,
        currentPage: null,
        keywords: '',
        multipleSelection: [],
        limit: 15,
        dialogVisible: false,
        direction: 'rtl',
        detail: []
      }
    },
    methods: {
      details(obj) {
        this.detail = obj
        this.dialogVisible = true
      },
      search() {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: 1 }})
      },
      selectItem(val) {
        this.multipleSelection = val
      },
      handleCurrentChange(page) {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: page }})
      },
      getAllUsers() {
        this.loading = true
        const data = {
          params: {
            keywords: this.keywords,
            page: this.currentPage,
            limit: this.limit
          }
        }
        this.apiGet('admin/bill', data).then((res) => {
          // console.log('res = ', _g.j2s(res))
          this.handelResponse(res, (data) => {
            this.tableData = data.list
            this.dataCount = data.dataCount
          })
        })
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.page) {
            this.currentPage = parseInt(data.page)
          } else {
            this.currentPage = 1
          }
        }
      },
      getKeywords() {
        let data = this.$route.query
        if (data) {
          if (data.keywords) {
            this.keywords = data.keywords
          } else {
            this.keywords = ''
          }
        }
      },
      init() {
        this.getKeywords()
        this.getCurrentPage()
        this.getAllUsers()
      }
    },
    created() {
      this.init()
    },
    computed: {
      addShow() {
        return _g.getHasRule('user-save')
      },
      editShow() {
        return _g.getHasRule('user-update')
      },
      deleteShow() {
        return _g.getHasRule('user-delete')
      }
    },
    watch: {
      '$route' (to, from) {
        this.init()
      }
    },
    components: {
      btnGroup
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// list.vue?7382d2a0